import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Course } from './model/course.model';
import { ErrorCode } from '../../models/error-code.model';

export const CourseApiActions = createActionGroup({
    source: 'API/Course',
    events: {
        'load courses': emptyProps(),
        'create course': props<{ course: Course }>(),
        'update course': props<{ course: Course }>(),
        'activate course': props<{ course: Course }>(),
        'deactivate course': props<{ course: Course }>(),
        'delete course': props<{ course: Course }>()
    }
});

export const CourseActions = createActionGroup({
    source: 'Course',
    events: {
        'load courses success': props<{ courses: Course[] }>(),
        'load courses failure': props<{ error: ErrorCode }>(),
        'create course success': props<{ course: Course }>(),
        'create course failure': props<{ error: ErrorCode }>(),
        'update course success': props<{ course: Course }>(),
        'update course failure': props<{ error: ErrorCode }>(),
        'delete course success': props<{ course: Course }>(),
        'delete course failure': props<{ error: ErrorCode }>(),
        'change active status success': props<{ course: Course }>(),
        'change active status failure': props<{ error: ErrorCode }>()
    }
});
